module.exports = __webpack_public_path__ + "img/非煤矿山.c7e55961.png";